<template>
  <div id="subapp-container">
    {{ title }}
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const title = ref('');

// 可以在这里根据路由参数动态设置标题
onMounted(() => {
  if (route.params.app === 'homeCare') {
    title.value = '居家养老';
  } else if (route.params.app === 'officerCare') {
    title.value = '干休所';
  } else if (route.params.app === 'educationCare') {
    title.value = '社区居家智慧养老平台';
  } else if (route.params.app === 'gtzhyl') {
    title.value = '居家及社区智慧养老平台';
  } else if (route.params.app === 'userManage') {
    title.value = '用户管理';
  } else {
    title.value = '子应用';
  }
});
</script>

<style scoped>
/* 样式可以根据需要添加 */
#subapp-container {
  margin: 0;
  padding: 0;
}
</style>
